import {
    LOGIC_OPERATOR_AND, LOGIC_OPERATOR_OR, LOGIC_OPERATOR_NOT, SECTION_TYPE_FIELD,
} from '../constants';

const RE_ENDS_WITH_LOGIC = new RegExp(`(${LOGIC_OPERATOR_AND}|${LOGIC_OPERATOR_OR}|${LOGIC_OPERATOR_NOT})$`);

export const formatKeyWord = (str, type) => {
    let htmlStr = str;
    if (type === SECTION_TYPE_FIELD) {
        const keyArr = str.split(':');
        if (keyArr.length === 2) {
            htmlStr = `<span class="field-name">${keyArr[0]}</span>:${keyArr[1]}`;
        }
    }
    return htmlStr;
};

export const isPatentNumber = () => true;

export const endsWithLogic = (value) => RE_ENDS_WITH_LOGIC.test(value.toUpperCase());
